module.exports = __webpack_public_path__ + "img/765.b789055a.png";